import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/shared/service/app-config.service';

@Injectable({
  providedIn: 'root'
})


export class EnvironmentconfigService {
  authConfig: any;
  msConfig: any;

  constructor(private ConfigService: AppConfigService) {
    var callbackUrl = this.ConfigService.getActualConfig('idmConfig.APPURL_FOR_IDM') + 'callback';
    var logoutUrl = this.ConfigService.getActualConfig('idmConfig.APPURL_FOR_IDM') + 'logout';
    var silentUrl = this.ConfigService.getActualConfig('idmConfig.APPURL_FOR_IDM') + 'silent';

    this.authConfig = {

      api_url: this.ConfigService.getActualConfig('idmConfig.IDM_URL'),//config.IDM_URL,
      authority: this.ConfigService.getActualConfig('idmConfig.IDM_URL') + '/auth/', // idm 登录地址
      client_id: this.ConfigService.getActualConfig('idmConfig.CLIENT_ID'),  // idm 客户端标识
      redirect_uri: callbackUrl,
      post_logout_redirect_uri: logoutUrl,
      response_type: 'code', // 无秘钥
      silent_redirect_uri: silentUrl,
      scope: 'openid profile  email offline_access',
      loadUserInfo: true,
      automaticSilentRenew: true,
      revokeAccessTokenOnSignout: true,
      filterProtocolClaims: false,
      matomoURL: this.ConfigService.getActualConfig('matomo.' + this.ConfigService.getActualConfig('env_type') + '.url'),
      matomoID: this.ConfigService.getActualConfig('matomo.' + this.ConfigService.getActualConfig('env_type') + '.id'),
      wmsmUrl: this.ConfigService.getActualConfig('wmsmUrl.' + this.ConfigService.getActualConfig('env_type')),
      wmsmStatus: this.ConfigService.getActualConfig('wmsm.status'),
      mmpUrl: this.ConfigService.getActualConfig('mmpUrl'),
      pmcsInboxUrl: this.ConfigService.getActualConfig('pmcsInboxUrl'),
      IT_email: this.ConfigService.getActualConfig('IT_email'),
      MVMBackEnd: this.ConfigService.getActualConfig('MVMBackEnd'),
      MVMSiteNew: this.ConfigService.getActualConfig('MVMSiteNew'),
      entraID: {
        auth: {
          clientId: this.ConfigService.getActualConfig('entraID.auth.clientId'),
          authority: this.ConfigService.getActualConfig('entraID.auth.authority'),
          redirectUri: this.ConfigService.getActualConfig('entraID.auth.redirectUri'),
        },
        scopes: this.ConfigService.getActualConfig('entraID.scopes')
      },
      switchTokenExpireNotification: this.ConfigService.getActualConfig('switchTokenExpireNotification')
      // silentRequestTimeout: 10000 // 10秒超时
    }

    // MS 相关配置单独分组
    this.msConfig = this.ConfigService.getActualConfig('msConfig');
  }
}

